/* GRATU — Agregar productos sugeridos desde el carrito (cross-sell).
   Se carga en todas las páginas: el carrito puede re-dibujarse sin ejecutar scripts. */
(function () {
  if (window.__gpCartUpsell) return;
  window.__gpCartUpsell = true;
  document.addEventListener('click', async function (e) {
    var b = e.target.closest('[data-gp-cu-add]');
    if (!b || b.disabled) return;
    e.preventDefault();
    e.stopPropagation();
    b.disabled = true;
    b.textContent = 'Agregando…';
    var ids = Array.prototype.map.call(
      document.querySelectorAll('cart-items-component[data-section-id]'),
      function (el) { return el.dataset.sectionId; }
    ).filter(Boolean);
    var root = (window.Theme && Theme.routes && Theme.routes.root) || '/';
    try {
      var res = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(b.dataset.gpCuAdd), quantity: 1 }], sections: ids.join(',') })
      });
      var data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || 'No se pudo agregar');
      var ev = new Event('cart:update', { bubbles: true });
      ev.detail = { resource: {}, sourceId: 'gratu-cart-upsell', data: { source: 'gratu-cart-upsell', itemCount: 1, sections: data.sections } };
      document.dispatchEvent(ev);
    } catch (err) {
      b.disabled = false;
      b.textContent = '+ Agregar';
    }
  }, true);
})();
